// automatically generated by yarn -config-overrides.js, do not modify

import Petition from '/var/www/proca/src/components/Petition.js'

import Share from '/var/www/proca/src/components/Share.js'
let steps={};
steps['Petition']=Petition;
steps['Share']=Share;
export {steps as allSteps}
export {steps}
